var map = {
	"./featured-item/coach.png": 238,
	"./featured-item/coach@2x.png": 166,
	"./featured-item/coach@3x.png": 168,
	"./featured-item/cuff.png": 240,
	"./featured-item/cuff@2x.png": 170,
	"./featured-item/cuff@3x.png": 172,
	"./featured-item/fastclix_lancets.png": 242,
	"./featured-item/fastclix_lancets@2x.png": 174,
	"./featured-item/fastclix_lancets@3x.png": 176,
	"./featured-item/fastclix_lancing_kit.png": 244,
	"./featured-item/fastclix_lancing_kit@2x.png": 178,
	"./featured-item/fastclix_lancing_kit@3x.png": 180,
	"./featured-item/guide.png": 246,
	"./featured-item/guide@2x.png": 182,
	"./featured-item/guide@3x.png": 184,
	"./featured-item/guide_me.png": 248,
	"./featured-item/guide_me@2x.png": 186,
	"./featured-item/guide_me@3x.png": 188,
	"./featured-item/mysugr_coach_voucher_based_1.png": 250,
	"./featured-item/mysugr_coach_voucher_based_1@2x.png": 190,
	"./featured-item/mysugr_coach_voucher_based_1@3x.png": 192,
	"./featured-item/pro.png": 252,
	"./featured-item/pro@2x.png": 194,
	"./featured-item/pro@3x.png": 196,
	"./featured-item/scale.png": 254,
	"./featured-item/scale@2x.png": 198,
	"./featured-item/scale@3x.png": 200,
	"./featured-item/softclix_lancets.png": 256,
	"./featured-item/softclix_lancets@2x.png": 202,
	"./featured-item/softclix_lancets@3x.png": 204,
	"./featured-item/softclix_lancing_kit.png": 258,
	"./featured-item/softclix_lancing_kit@2x.png": 206,
	"./featured-item/softclix_lancing_kit@3x.png": 208,
	"./featured-item/strips_subscription_guide.png": 260,
	"./featured-item/strips_subscription_guide@2x.png": 210,
	"./featured-item/strips_subscription_guide@3x.png": 212,
	"./item/coach.png": 657,
	"./item/coach@2x.png": 267,
	"./item/coach@3x.png": 268,
	"./item/cuff.png": 658,
	"./item/cuff@2x.png": 269,
	"./item/cuff@3x.png": 270,
	"./item/fastclix_lancets.png": 659,
	"./item/fastclix_lancets@2x.png": 271,
	"./item/fastclix_lancets@3x.png": 272,
	"./item/fastclix_lancing_kit.png": 660,
	"./item/fastclix_lancing_kit@2x.png": 273,
	"./item/fastclix_lancing_kit@3x.png": 274,
	"./item/guide.png": 661,
	"./item/guide@2x.png": 275,
	"./item/guide@3x.png": 276,
	"./item/guide_me.png": 662,
	"./item/guide_me@2x.png": 277,
	"./item/guide_me@3x.png": 278,
	"./item/guide_strips.png": 663,
	"./item/guide_strips@2x.png": 279,
	"./item/guide_strips@3x.png": 280,
	"./item/mysugr_coach_voucher_based_1.png": 664,
	"./item/mysugr_coach_voucher_based_1@2x.png": 281,
	"./item/mysugr_coach_voucher_based_1@3x.png": 282,
	"./item/pro.png": 665,
	"./item/pro@2x.png": 283,
	"./item/pro@3x.png": 284,
	"./item/scale.png": 666,
	"./item/scale@2x.png": 285,
	"./item/scale@3x.png": 286,
	"./item/softclix_lancets.png": 667,
	"./item/softclix_lancets@2x.png": 287,
	"./item/softclix_lancets@3x.png": 288,
	"./item/softclix_lancing_kit.png": 668,
	"./item/softclix_lancing_kit@2x.png": 289,
	"./item/softclix_lancing_kit@3x.png": 290,
	"./item/strips_subscription_guide.png": 669,
	"./item/strips_subscription_guide@2x.png": 291,
	"./item/strips_subscription_guide@3x.png": 292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 266;